import axiosNew from '../../helpers/axios'

export const listHomeProjects = ({ skip = 0, limit = 12 } = {}) =>
    axiosNew({
        url: 'support/home/projects',
        method: 'GET',
        params: { skip, limit },
    })

export const listHomePeople = ({ skip = 0, limit = 12 } = {}) =>
    axiosNew({
        url: 'support/home/people',
        method: 'GET',
        params: { skip, limit },
    })

export const listHomeTasks = ({ skip = 0, limit = 12 } = {}) =>
    axiosNew({
        url: 'support/home/tasks',
        method: 'GET',
        params: { skip, limit },
    })

